import { render, staticRenderFns } from "./AppModalEmbedded.vue?vue&type=template&id=0b043079"
import script from "./AppModalEmbedded.vue?vue&type=script&lang=js"
export * from "./AppModalEmbedded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports